module.exports = __webpack_public_path__ + "media/images/icons/fork-9c1ad65aa3f47564faf35d6af0308962.svg";